<template>
	<div style="background: #f4f4f4;">
		<div class="containerTop">
			<div style="width: 1200px;margin: 0 auto;">
				<div class="searchPart">
					<div class="searchPartLeft">
						<div style="font-size: 18px;color: #000;font-weight: 600;line-height: 22px;">
							应用市场
						</div>
						<div style="padding-top: 5px;font-size: 12px;color: #DBDBDB;text-transform: uppercase;">
							SOFTMARKET
						</div>
					</div>
					<div class="searchContainer">
						<div class="flex searchContainerone" @keyup.enter="getSassOne()">
							<el-input placeholder="在此输入你需要的服务" v-model="searchInputValue" class="input-with-select">
								<el-button slot="append" @click="getSassOne()">
									<i class="el-icon-search" style="font-size: 24px"></i>
								</el-button>
							</el-input>
						</div>

						<ul>
							<li class="textLi" v-for="(dictionary, index) in hotSearch" :key="index"
								@click="findHotSearch(dictionary.name)">{{dictionary.name}}
							</li>
						</ul>
					</div>
				</div>
				<div class="flex" style="align-items: center;">
					<div class="classify">
						<span>应用分类</span>
					</div>
					<span style="font-size: 14px;padding-left: 5px;">当前位置：</span>
					<el-breadcrumb separator-class="el-icon-arrow-right">

						<el-breadcrumb-item v-if="this.titleIndex == 'list'" style="cursor: pointer;"
							:to="{name: 'saasList', params: { tabParam: this.tabParam }}">{{titleName}}
						</el-breadcrumb-item>
						<el-breadcrumb-item v-if="this.titleIndex == 'index'" style="cursor: pointer;"
							:to="{name: 'apps'}">{{titleName}}
						</el-breadcrumb-item>

						<!--     <el-breadcrumb-item>软件市场</el-breadcrumb-item>-->
						<el-breadcrumb-item>应用详情</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
			</div>
		</div>
		<div class="container">
			<section>
				<el-row :gutter="30" class="containerStyleClass">
					<el-col :span="18" style="padding: 0;">
						<div class="containerLeftTop">
							<div class="softwareLogo">
								<img style="width: 110px; height: 110px;" :src="software.softwareLogo">
								</img>
							</div>
							<div class="softwareRight">
								<div class="topServBoxInfo">
									<div class="collectionClass">
										<i v-if="collectionState" class="el-icon-star-on"
											style="margin-right: 8px;color: #E6A23C;cursor: pointer;font-size: 24px;"
											@click="updateCollection"></i>
										<i v-if="!collectionState" class="el-icon-star-off"
											style="margin-right: 8px;cursor: pointer;font-size: 22px;"
											@click="updateCollection"></i>
										<span style="font-size: 16px;"> {{software.collectionsNum}} </span>
									</div>
									<!--  <el-button v-if="!collectionState" @click="updateCollection" icon="el-icon-star-off"
                                               size="mini" style="float: right;"></el-button>
                                    <el-button v-if="collectionState" @click="updateCollection" type="warning"
                                               icon="el-icon-star-off" size="mini" style="float: right;"></el-button>-->
									<h3>{{software.softwareName}}</h3>
									<p :title="software.description">{{ software.description}}</p>
								</div>
								<div class="businessVolume">
									<div class="businessVolumeLeft">
										近180天成交量：{{halfYearSales}}笔
									</div>
									<div class="businessVolumeRight">
										<span>用户评分：</span>
										<el-rate :value='software.score' disabled
											:colors="['#F7BA2A', '#F7BA2A','#Da251d']">
										</el-rate>
									</div>
								</div>
								<el-form ref="form" :label-width="software.canBuy == 0 ? '0':'80px'" class="buySoftwareForm">
									<el-form-item label="套餐版本："  v-if="software.canBuy != 0">
										<el-radio-group size="medium" v-model="modelId">
											<el-radio-button :label="model.uuid"
												v-for="(model,index) in software.modelList" :key="index"
												@click.native="updatePrice(model.price,model.billingMode,model)">
												{{model.modelDescription}}\{{model.billingModeName}}
											</el-radio-button>
										</el-radio-group>
									</el-form-item>
									<el-form-item label="购买时长："  v-if="software.canBuy != 0">
										<el-input-number @change="numChange" :min="1" :max="maxNum" label="购买时长："
											v-model="num"></el-input-number>
										<span v-if="billingModeName">/{{billingModeName}}</span>
									</el-form-item>
									<el-form-item label="金额："  v-if="software.canBuy != 0">
										<p style="color: #da251d; font-size: 16px;">
											<span>¥</span>{{number_format(allPrice,
                                            2, ".", ",")}}<span>元</span></p>
									</el-form-item>

									<el-form-item size="large" class="buySoftwareFormSubmit">
										 <el-popover :visible="visible" placement="right-start" :width="160" v-if="software.canBuy == 0">
											 <div style="text-align: center;">
												 <p>扫码联系微信客服</p>
												 <img style="width:130px;height:130px;"
												 	src="../../assets/微信二维码.png">
											 </div>
										<template #reference>
										<el-button  type="primary" @click="visible = true">立即联系</el-button>
										 </template>
										</el-popover>



										<el-button
											v-else-if="$store.state.isUsermessage.identity == 'STAFF' || isDesigner"
											disabled="" type="info">立即购买</el-button>
										<el-button type="primary" v-else @click="saveSoftwareOrder">立即购买</el-button>

									</el-form-item>
								</el-form>
							</div>
						</div>
						<div class="containerLeftBottom">
							<ul>
								<li>
									<a @click.prevent="anchor('softwareDetailPart')">产品详情</a>
								</li>
								<li>
									<a @click.prevent="anchor('softwarePricePart')">产品价格</a>
								</li>
								<li>
									<a @click.prevent="anchor('softwareClientPart')">客户案例</a>
								</li>
								<li>
									<a @click.prevent="anchor('softwareEvaluatePart')">用户评价</a>
								</li>
							</ul>
							<div class="softwareDetailIntroduce">
								<div class="softwareDetailPart">
									<div class="title" id="softwareDetailPart">产品详情：</div>
									<div class="content editorStyleDetailContent vHtmlMess"
										v-html="software.details?software.details:'暂无产品详情介绍!'"></div>
								</div>
								<div class="softwareDetailPart">
									<div class="title" id="softwarePricePart">产品价格：</div>
									<div class="content editorStyleDetailContent vHtmlMess"
										v-html="software.priceDetail?software.priceDetail:'暂无产品价格介绍!'"></div>
								</div>
								<div class="softwareDetailPart">
									<div class="title" id="softwareClientPart">客户案例：</div>
									<div class="content">
										<ul v-if="caseList.length > 0">
											<li v-for="item in caseList" :key="item.uuid">
												<h4>{{item.caseName}}</h4>
												<div class="editorStyleDetailContent softwareClientContent vHtmlMess"
													v-html="item.detail"></div>
											</li>
										</ul>
										<span v-else>暂无客户案例！</span>
									</div>
								</div>
								<div class="softwareDetailPart">
									<div class="title" id="softwareEvaluatePart">用户评价：</div>

									<div v-if="commentList.length != 0" v-loading="loading">
										<div class="flex right_sortbox">
											<p :class="sortboxIndex == index ? 'p_active' : ''"
												v-for="(items, index) in sortBox" :key="index"
												@click="getSortBox(index)">
												{{ items.name }} ({{ items.num }})
											</p>
										</div>
										<div v-for="(items, index) in commentList" :key="index">
											<div class="comList flex">
												<div class="flex">
													<div class="comList_img">
														<img :src="items.image" alt="" />
													</div>
													<div class="comList_con">
														<p class="con_title">{{ items.title }}</p>
														<p class="con_mess">
															{{ items.messages }}
														</p>
														<span> {{ items.time }}</span>
													</div>
												</div>

												<div class="comList_star">
													<div class="comList_star_A flex">
														<span>描述相符</span>
														<el-rate v-model="items.designerStar" disabled :colors="colors">
														</el-rate>
													</div>
													<div class="comList_star_A flex">
														<span>服务态度</span>
														<el-rate v-model="items.designerStar2" disabled
															:colors="colors">
														</el-rate>
													</div>
													<div class="comList_star_A flex">
														<span>专业程度</span>
														<el-rate v-model="items.designerStar3" disabled
															:colors="colors">
														</el-rate>
													</div>
												</div>
											</div>
											<!-- 回复 -->
											<div v-if="items.reply" class="additional_evaluation">
												设计师回复：{{items.reply}}
											</div>
										</div>
										<div style="text-align: right; padding: 0 0px 30px;margin-top:20px">
											<el-pagination background @current-change="handleCurrentChange1"
												@prev-click="handleCurrentChange1" @next-click="handleCurrentChange1"
												layout="total,prev, pager, next,jumper" :current-page="current1"
												:page-size="pageSize1" :total="total1" class="pagination">
											</el-pagination>
										</div>
									</div>
									<div class="content" v-loading="loading" v-else>期待您的评价！</div>
								</div>
							</div>
						</div>
					</el-col>
					<el-col :span="6">
						<div class="relatedRecommendation " v-if="recommendList && recommendList.length > 0">
							<div class="printTitle">相关推荐</div>
							<ul class="simSoft">
								<li v-for="(software, index) in recommendList" :key="index">
									<el-image @click="getSassDetails(software.uuid)"
										style="width: 75px; height: 75px; margin-bottom: 5px ;cursor: pointer;"
										:src="software.softwareLogo">
									</el-image>
									<div style="padding: 10px;">
										<div style="cursor: pointer;font-size: 14px;color: #333;margin: 5px 0;"
											@click="getSassDetails(software.uuid)">{{ software.softwareName }}
										</div>
										<p class="sPrice" style="font-size: 12px;color: #f00;line-height: 1.8;" v-if="software.canBuy == 0" >
											暂无价格
										</p>
										<p class="sPrice" style="font-size: 12px;color: #f00;line-height: 1.8;" v-else>
											{{number_format(software.price, 2, ".", ",")}} <span
												style="font-size: 12px;color: #8c8a8c;">元/{{software.billingModeUnit}}起</span>
										</p>
									</div>
								</li>
							</ul>
						</div>
						<div class="relatedRecommendation" style="margin-top: 10px;">
							<div class="printTitle">大家都在找</div>
							<div class="hotRecommendation">
								<span v-for="(dictionary, index) in hotSearch" :key="index"
									@click="findHotSearch(dictionary.name)">{{dictionary.name}} </span>
							</div>
						</div>
					</el-col>
				</el-row>
			</section>
		</div>
	</div>
</template>

<script>
	import {
		getNewcurrent,
		getSoftwareDetail,
		getSoftwareDetailViewRecommend,
		getSoftwareSalesByHalfYear,
		saveSaftwareOrder,
		updateSoftwarePageViews,
		findIsCollectionByUserAndSoftId,
		delCollection,
		saveCollection,
		getIndexDictionaryData,
		findSoftwareCase,
		saveVisitorLog,
		getEvaluationList,
		getUserInfo,
		designerByUserId,
		getTagsByGoodsId,
	} from "../../utils/interface";
	import {
		mapState,
		mapMutations
	} from "vuex";
	export default {
		//   软件超市详情页
		name: "saasDetails",
		metaInfo() {
			return {
				title: this.metaTitle,
				meta: [{ // set meta
						name: "keywords",
						content: this.metaKeywords,
					},
					{ // set meta
						name: "description",
						content: this.metaDescription,
					}
				],
			}
		},
		components: {},

		data() {
			return {
				url: require("../../assets/软件超市/精品/铸造执行系统MES.png"),
				bannerList: [{
					value: require("../../assets/image/zrcs.jpg"),
				}, ],
				searchInputValue: '',
				description: '应用的简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介介简介简介',
				typeCheckValue: 'one',
				buyNum: '1',
				titleName: "",
				hotSearch: [],
				titleIndex: "",
				tabParam: "",
				id: "",
				software: {},
				setIn: null,
				price: 0.00,
				maxNum: 36,
				allPrice: 0.00,
				num: 1,
				visible:false,
				modelId: '',
				recommendList: [],
				halfYearSales: 0,
				userDetail: {},
				collectionState: false,
				caseList: [],
				billingModeName: '',
				commentList: [],
				current1: 1,
				total1: 0,
				pageSize1: 5,
				form: {},
				sortBox: [],
				sortboxIndex: "0",
				colors: ["#D91E1E", "#D91E1E", "#D91E1E"],
				isDesigner: false,
				metaTitle: '',
				metaKeywords: '',
				metaDescription: '',
			};
		},
		created() {
			this.getParams();
			this.getSoftwareDetail();
			this.updateSoftwarePageViews();
			this.getNewcurrent();
			this.getHostSearch();
			this.conmmentList();
		},
		methods: {


			getSortBox(index) {
				this.sortboxIndex = index;
				this.handleCurrentChange1(1);
			},
			/*锚链接跳转*/
			anchor(anchorName) {
				/*找到锚点*/
				let anchorElement = document.getElementById(anchorName);
				window.scrollTo({
					top: anchorElement.offsetTop + 70,
					behavior: "smooth",
				});
			},
			// 分页
			handleCurrentChange1(val) {
				this.current1 = val
				window.scrollTo(0, 0);
				this.conmmentList();
			},
			conmmentList() {
				if (this.sortBox.length > 1) {
					this.form.tags = this.sortBox[this.sortboxIndex].id;
				}
				this.loading = true
				this.form.uuid = this.$route.params.uuid;
				this.form.orderType = 'SOFTWARE';
				this.form.evaluationType = 'NORMAL';
				this.form.current = this.current1;
				this.form.pageSize = this.pageSize1;
				getEvaluationList(this.form).then((res) => {
					if (res != null && res.list != null && res.list.length > 0) {
						this.total1 = res.total;
						this.commentList = [];
						if (this.sortBox.length == 0) {
							this.sortBox.push({
								name: '全部',
								num: res.total
							});
						}
						if (this.sortBox.length == 1) {
							getTagsByGoodsId(this.form).then((res) => {
								if (res != null && res.length > 0) {
									res.forEach((items, index) => {
										this.sortBox.push({
											id: items.tagUuid,
											name: items.tagName,
											num: items.evaluationNum,
										});
									});
								}
							});
						}
						res.list.forEach((item, index) => {
							let evaluation = {};
							evaluation.order = item;
							evaluation.uuid = item.uuid;
							evaluation.title = item.creator;
							evaluation.messages = item.evaluationContent;
							evaluation.designerStar = parseInt(item.descriptionPoint);
							evaluation.designerStar2 = parseInt(item.servicePoint);
							evaluation.designerStar3 = parseInt(item.transportPoint);
							evaluation.time = item.createTime
							evaluation.image = (item.iconUrl ? item.iconUrl : require(
								'../../assets/设计市场/头像1.jpeg'));

							if (item.addedReplys != null && item.addedReplys.length > 0) {
								item.addedReplys.some((item, index) => {
									if (item.evaluationType == 'REPLY') {
										evaluation.reply = item.evaluationContent;
										return true;
									}
								});
							}
							this.commentList.push(evaluation);
						});
						this.loading = false
					} else {
						this.total1 = 0;
						this.loading = false
					}
				});
			},
			findHotSearch(searchName) {
				this.searchInputValue = searchName;
				this.getSassOne()
			},
			getHostSearch() {
				getIndexDictionaryData({
						groupCode: "RJRS",
					}).then((response) => {
						this.hotSearch = response;
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			updateCollection() {
				let isCollection = this.collectionState;
				let uuid = this.id;
				if (!this.$store.state.isLogin) {

					/* this.$alert("当前用户未登陆！", "提示", {
					     confirmButtonText: "确定",
					 });*/
					this.$router.push({
						name: "login",
						params: {
							uuid: uuid
						}
					});
					return;
				}
				if (isCollection) {
					let params = {
						softwareId: uuid,
						userId: this.userDetail.uuid
					}
					delCollection(params).then((res) => {
						this.collectionState = !this.collectionState;
						this.getSoftwareDetail();
					})
				} else if (!isCollection) {
					let params = {
						softwareId: uuid,
						userId: this.userDetail.uuid
					}
					saveCollection(params).then((res) => {
						this.collectionState = !this.collectionState;
						this.getSoftwareDetail();
					})
				}

			},
			findIsCollectionByUserAndSoftId() {
				if (!this.$store.state.isLogin) {
					/*       this.$alert("当前用户未登陆！", "提示", {
					           confirmButtonText: "确定",
					       });*/
					this.$router.push({
						name: "login",
						params: {
							uuid: uuid
						}
					});
					return;
				}
				let param = {
					userId: this.userDetail.uuid,
					softwareId: this.id
				}
				findIsCollectionByUserAndSoftId(param).then((res) => {
					console.log(res)
					this.collectionState = res;
				})
			},
			getSassDetails(uuid) {
				let routeData = this.$router.resolve({
					name: "saasDetails",
					params: {
						uuid: uuid
					},
					query: {
						titleName: "应用列表",
						titleIndex: "list",
						tabParam: this.tabParam,
					}
				});
				window.open(routeData.href, "_blank");
			},
			getNewcurrent() {
				if (!this.$store.state.isLogin) {
					return;
				}
				getNewcurrent().then((res) => {
					console.log(res)
					this.userDetail = res;
					this.findIsCollectionByUserAndSoftId();
					designerByUserId(this.userDetail.uuid).then((res) => {
						if (res != null && res.status == 'PASS') {
							this.isDesigner = true;
						}
					});
				})
			},
			getParams() {
				this.id = this.$route.params.uuid;
				this.titleName = this.$route.query.titleName;
				this.titleIndex = this.$route.query.titleIndex;
				if (this.titleIndex == "list") {
					this.tabParam = this.$route.query.tabParam;
				}
			},
			updateSoftwarePageViews() {
				let param = {
					softwareId: this.id,
				}
				updateSoftwarePageViews(param);
			},
			numChange(value) {
				this.num = value;
				this.allPrice = value * this.price;
			},
			getSoftwareDetail() {
				getSoftwareDetail(this.id).then((res) => {
					this.software = res;
					this.metaTitle = res.softwareName + "-" + res.typeName + "-增材云";
					this.metaKeywords = res.metaKeywords;
					this.metaDescription = res.metaDescription;

					this.modelObj = res.modelList[0];
					this.price = res.modelList[0].price;
					this.allPrice = this.num * this.price;
					this.modelId = res.modelList[0].uuid;
					this.billingModeName = res.modelList[0].billingModeName;
					let param = {
						softwareType: res.softwareType,
						size: 3,
						softwareId: res.uuid,
					}
					//足迹
					this.saveVisitorLog();

					getSoftwareDetailViewRecommend(param).then((res) => {
						this.recommendList = res;
					})
					let param1 = {
						softwareId: res.uuid,
					}
					getSoftwareSalesByHalfYear(param1).then((res) => {
						this.halfYearSales = res;
					})
				})
				let param = {
					softwareId: this.id
				}
				findSoftwareCase(param).then((res) => {
					if (res) {
						this.caseList = res
					}
				})
			},
			saveSoftwareOrder() {
				let identity = this.$store.state.isUsermessage.identity
				if (!this.$store.state.isLogin) {
					/*this.$message({
					    message: '当前用户未登陆！',
					    type: 'warning'
					});*/
					/*   this.$alert("当前用户未登陆！", "提示", {
					       confirmButtonText: "确定",
					   });*/

					this.$router.push({
						name: "login"
					});
					return false;
				} else if (identity == 'ANONYMOUS') {
					this.$confirm('请先进行实名认证！', '提示', {
						confirmButtonText: '去认证',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$router.push('/userCenter/10')
					}).catch(() => {
						this.$message({
							type: 'info',
							message: '已取消'
						});
					});
				} else if (identity == 'PERSONAL') {
					this.$confirm('您尚未进行企业资质认证，无法购买应用！', '提示', {
						confirmButtonText: '去认证',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$router.push('/userCenter/11')
					}).catch(() => {
						this.$message({
							type: 'info',
							message: '已取消'
						});
					});
				} else {
					let order = {
						state: 1000,
						remarks: '',
						softwareType: this.software.softwareType,
						softwareTypeName: this.software.typeName,
						softwareId: this.software.uuid,
						softwareName: this.software.softwareName,
						softwareModelId: this.modelObj.uuid,
						softwareModelName: this.modelObj.modelDescription,
						modelPrice: this.modelObj.price,
						billingMode: this.modelObj.billingMode,
						billingModeName: this.modelObj.billingModeName,
						buyNum: this.num,
						allPrice: this.allPrice,
						payableAmount: this.allPrice,
						actualPayment: this.allPrice,
						userId: this.userDetail.uuid,
						userName: this.userDetail.name,
					}
					saveSaftwareOrder(order).then((res) => {
						this.$alert("订单提交成功", "提示", {
							confirmButtonText: "确定",
						});
					})
				}
			},
			updatePrice(price, modelId, model) {
				if (modelId == "1203") {
					this.num = 1;
					this.maxNum = 1;
				} else {
					this.maxNum = 36;
				}
				this.modelObj = model;
				this.price = price;
				this.billingModeName = model.billingModeName
				this.allPrice = this.num * this.price;
			},
			getSassOne(tabParam) {
				if (tabParam == null) {
					tabParam = "NEW";
				}
				let routeData = this.$router.resolve({
					path: "/appsList",
					query: {
						tabParam: tabParam,
						search: this.searchInputValue
					}
				});
				this.searchInputValue = ''
				window.open(routeData.href, "_blank");
			},
			number_format(number, decimals, dec_point, thousands_sep) {
				/*
				 * 参数说明：
				 * number：要格式化的数字
				 * decimals：保留几位小数
				 * dec_point：小数点符号
				 * thousands_sep：千分位符号
				 * */
				number = (number + '').replace(/[^0-9+-Ee.]/g, '');
				var n = !isFinite(+number) ? 0 : +number,
					prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
					sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
					dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
					s = '',
					toFixedFix = function(n, prec) {
						var k = Math.pow(10, prec);
						return '' + Math.ceil(n * k) / k;
					};

				s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
				var re = /(-?\d+)(\d{3})/;
				while (re.test(s[0])) {
					s[0] = s[0].replace(re, "$1" + sep + "$2");
				}

				if ((s[1] || '').length < prec) {
					s[1] = s[1] || '';
					s[1] += new Array(prec - s[1].length + 1).join('0');
				}
				return s.join(dec);
			},
			saveVisitorLog() {
				let param = {
					title: this.software.softwareName,
					logo: this.software.softwareLogo,
					visitorType: 'SOFTWARE',
					price: this.price,
					link: window.location.href
				};
				saveVisitorLog(param);
			},
			//微信二维码
			gotoWX(str) {
				let rwm = document.getElementById("wx");
				if (str == "0") {
					rwm.style.display = "block";
				}

			}
		},
	};
</script>

<style scoped lang="less">
	.scanCode {
		font-size: 14px;
		display: block;
		font-size: 13px;
		color: black;
		text-align: center;
		width: 100%;
		margin-top: -10px;
		margin-bottom: 5px;
		font-family: Microsoft YaHei, PingFang SC, Lantinghei SC, Helvetica Neue, Helvetica, Arial, \\5FAE\8F6F\96C5\9ED1, STHeitiSC-Light, simsun, \\5B8B\4F53, WenQuanYi Zen Hei, WenQuanYi Micro Hei, "sans-serif";
	}

	.containerTop {
		background: #fff;
		margin-bottom: 10px;

		.searchPart {
			width: 100%;
			padding: 18px 0 5px;
			display: flex;

			.searchContainer {
				// width: 690px;
				margin: 0 auto;
				padding: 0 15px;

				.searchContainerone {
					.input-with-select {
						flex-shrink: 0;
					}

					.searchContainerButton {
						color: #157efb;
						margin-left: 15px;
						border: 1px solid #157efb;
						width: 88px;
						background: #fff;
						font-size: 14px;
						border-radius: 10px;
					}
				}

				/deep/ .input-with-select .el-input__inner {
					border: 2px solid #157efb;
					border-top-left-radius: 10px;
					border-bottom-left-radius: 10px;
					background: #fdfdfd;
					height: 40px;
					line-height: 40px;
				}

				/deep/ .el-input-group {
					height: 40px;
					width: 618px;
				}

				/deep/ .input-with-select .el-input-group__append {
					background: #157efb;
					color: #fff;
					border: 1px solid #157efb;
					border-left: none;
					border-radius: 0px 10px 10px 0px;
					width: 80px;
					box-sizing: border-box;
					text-align: center;
				}

				ul {
					display: flex;
					color: #c0c0c0;
					padding-left: 3px;

					li {
						font-size: 12px;
						padding: 8px 20px 0 0;

						&.textLi {
							padding: 10px 20px 0 0;
							cursor: pointer;

							&:hover {
								color: #157efb;
							}
						}
					}
				}
			}
		}

		.classify {
			width: 235px;
			color: #fff;
			background: #000;
			height: 35px;
			line-height: 35px;
			padding: 0 10px;
			box-sizing: border-box;
			cursor: pointer;

			span {
				font-weight: 700;
				font-size: 14px;
				padding-left: 5px;
			}
		}
	}

	.container {
		width: 1200px;
		margin: 0 auto;

		.containerStyleClass {
			box-sizing: border-box;
			margin: 0 !important;

			.containerLeftTop {
				background: #fff;
				padding: 30px;
				box-sizing: border-box;
				display: flex;

				.softwareLogo {
					width: 150px;
				}

				.softwareRight {
					width: 720px;

					.topServBoxInfo {
						position: relative;

						h3 {
							font-family: "Roboto Slab", Helvetica, Arial, sans-serif;
							font-weight: 500;
							font-size: 18px;
							margin-bottom: 7px;
							color: #2c2f37;
						}

						p {
							font-size: 12px;
							color: #2c2f37;
							line-height: 20px;
						}

						.collectionClass {
							position: absolute;
							right: 0;
							top: 0;
							display: flex;
							justify-items: center;
							color: #c9c9c9;

							span {
								font-size: 16px;
							}
						}
					}

					.businessVolume {
						background-color: rgba(229, 125, 32, 0.1);
						margin: 10px 0 20px;
						display: flex;

						.businessVolumeLeft {
							padding: 15px;
							width: 50%;
							box-sizing: border-box;
							font-weight: 500;
							color: rgba(0, 0, 0, 0.7);
							font-size: 14px;
						}

						.businessVolumeRight {
							padding: 15px;
							width: 50%;
							box-sizing: border-box;
							display: flex;
							border-left: 1px solid #ccc;
							color: #999;
							font-size: 14px;
						}
					}

					.buySoftwareForm {
						/deep/ .el-form-item__label {
							padding: 0 10px 0 0;
							color: #2c2f37;
							font-size: 13px;
						}

						/deep/ .el-radio-button__inner {
							margin: 0 10px 10px 0;
							border: 1px solid #eee;
							border-radius: 0;

							&:hover {
								color: #2c2f37;
								background-color: #eee;
							}
						}

						/deep/ .el-radio-button__orig-radio:checked+.el-radio-button__inner {
							color: #FFF;
							background-color: #157efb;
							border-color: #157efb;
							-webkit-box-shadow: -1px 0 0 0 #157efb;
							box-shadow: -1px 0 0 0 #157efb;
						}

						/deep/ .el-form-item {
							margin-bottom: 15px !important;
						}

						.buySoftwareFormSubmit {
							/deep/ .el-form-item__content {
								.el-button--primary {
									background-color: #157efb;
									border-color: #157efb;
									-webkit-border-radius: 10px;
									-moz-border-radius: 10px;
									border-radius: 10px;

									&:hover {
										background: #59a2f9;
										border-color: #59a2f9;
									}
								}
							}
						}
					}
				}
			}

			.containerLeftBottom {
				background: #fff;
				padding: 30px;
				box-sizing: border-box;
				margin-top: 10px;

				ul {
					display: flex;
					line-height: 38px;
					border-bottom: 1px solid #eee;

					li {
						padding-right: 30px;

						a {
							color: #2c2f37;
							font-size: 14px;
							cursor: pointer;
						}

						&:hover {
							a {
								color: #157efb;
							}
						}
					}
				}

				.softwareDetailIntroduce {
					.softwareDetailPart {
						padding: 10px 0;
						border-bottom: 1px #eae7e7 dashed;

						.title {
							line-height: 42px;
							color: #2c2f37;
							font-size: 14px;
							font-weight: 600;
						}

						.content {
							font-size: 12px;
							color: #2c2f37;
							line-height: 1.6;

							ul {
								line-height: 25px;
								border: none;
								display: block;

								li {
									padding: 15px 20px;
									background: #f4f4f4;
									margin-bottom: 15px;

									&:last-child {
										margin: 0;
									}
								}
							}
						}
					}

					.editorStyleDetailContent {
						/deep/img {
							max-width: 100%;
						}
					}
				}
			}

			.relatedRecommendation {
				box-sizing: border-box;
				background: #fff;

				.printTitle {
					padding: 15px;
					text-align: left;
					box-sizing: border-box;
					border-bottom: 1px solid #eee;
					color: #157efb;
					margin: 0;
					font-size: 16px;
					font-weight: 600;
				}

				ul {
					li {
						padding-top: 10px;
						border-bottom: 1px dashed #eee;
						text-align: center;
						margin-bottom: 0;
					}
				}

				.hotRecommendation {
					padding: 10px;
					display: flex;
					flex-wrap: wrap;

					span {
						padding: 4px 7px;
						font-size: 12px;
						margin: 0 7px 10px 0;
						color: #2c2f37;
						cursor: pointer;
						display: block;

						&:hover {
							color: #157efb;
						}
					}
				}
			}
		}
	}

	.printTitle {
		font-size: 28px;
		font-weight: normal;
		color: #157EFB;
		margin-top: 60px;
		margin-bottom: 30px;
		border-bottom: 1px solid #e3e3e3;
		padding-bottom: 10px;

		span.tit {
			padding-bottom: 10px;
			border-bottom: 1px solid #157EFB;
		}

		span.more {
			font-size: 16px;
			float: right;
			margin-top: 10px;
		}

		.more i {
			color: #505050 !important;
		}
	}

	.content {
		/deep/ .el-col-4 {
			width: 20%
		}
	}

	.box-card {
		border: 1px solid #e3e3e3;
		margin-bottom: 30px;
		font-size: 12px;

		h2 {
			font-size: 16px;
			margin-bottom: 5px;
		}

		.sDetail {
			font-size: 14px;
			margin: 15px auto;
			text-align: left;
		}

		.sPrice {
			font-size: 16px;
			color: #da251d;
			margin-bottom: 15px;

			span {
				font-size: 12px;
			}
		}

		.image {
			width: 64px;
			height: 64px;
			margin-top: 15px;
		}
	}

	.mpFooter {
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-top: 1px solid #EBEEF5;
		margin: 0 -21px -15px;
		padding: 10px 20px;

		a {
			color: #505050;
		}
	}

	.hotSellServ {
		display: flex;
		align-items: center;

		p {
			/*text-align: center;*/
			font-size: 14px;
			color: #585858;
		}

		.topServBoxInfo h3 {
			font-size: 16px;
			margin-bottom: 6px;
			font-weight: normal;
		}

	}

	.simSoft li {
		margin: 0 0 30px 0;
	}

	.bottomTxt {
		margin-top: 15px;
		font-size: 13px;
		text-align: left;
	}

	.clearfix:before,
	.clearfix:after {
		display: table;
		content: "";
	}

	.clearfix:after {
		clear: both
	}

	// 评价
	.right_sortbox {
		font-size: 14px;
		height: 32px;
		line-height: 32px;
		margin-bottom: 15px;
		margin-top: 20px;

		p {
			cursor: pointer;
			margin-right: 40px;
			padding: 0 10px;
		}

		.p_active {
			color: #1181ff;
			background: #f3f8ff;
			border-radius: 8px;
		}
	}

	.comList {
		border: 1px solid #efefef;
		border-radius: 10px;
		width: 100%;
		padding: 15px;
		box-sizing: border-box;
		-moz-box-sizing: border-box;
		/* Firefox */
		-webkit-box-sizing: border-box;
		/* Safari */
		margin-top: 15px;
		background: #fff;
		justify-content: space-between;
		align-items: center;

		.comList_img {
			width: 66px;
			height: 66px;
			background: #efefef;
			border-radius: 50%;
			margin-right: 15px;

			img {
				width: 100%;
				height: 100%;
				border-radius: 50%;
			}
		}

		.comList_con {
			color: #777;
			margin-right: 10px;
			flex: 1;

			.con_title {
				font-size: 16px;
				margin-bottom: 5px;
			}

			.con_mess {
				font-size: 14px;
			}

			span {
				color: rgb(194, 194, 194);
				font-size: 12px;
			}
		}

		.comList_star {
			flex-shrink: 0;

			.comList_star_A {
				align-content: center;
				margin-bottom: 3px;

				span {
					color: rgb(194, 194, 194);
					font-size: 13px;
					margin-right: 5px;
					line-height: 22px;
				}
			}
		}
	}

	.additional_evaluation {
		font-size: 14px;
		color: #AF874D;
		width: 80%;
		margin-bottom: 20px;
		line-height: 24px;
		background: #efefef7a;
		border-radius: 10px;
		padding: 20px;
		margin-top: 8px;
	}
</style>



// WEBPACK FOOTER //
// src/components/saas/saasDetails.vue